"use strict";

import { PeriodUtils } from "./period.utils";

/**
 * @ngdoc function
 * @name diceApp.component:dicePeriodProgress
 * @description Shows the progress of each period.
 */
angular.module("diceApp").component("dicePeriodProgress", {
  templateUrl: "es6/period/period.progress.html",
  controllerAs: "periodProgressController",
  controller: function (Period) {
    const periodProgressController = this;

    periodProgressController.$onInit = function () {
      periodProgressController.loading = true;

      Period.progress()
        .$promise.then((periods) => {
          periodProgressController.periods = PeriodUtils.sortNewestFirst(periods);
        })
        .finally(() => {
          periodProgressController.loading = false;
        });
    };
  }
});
